import React, { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import Swal from "sweetalert2";
import AnimationSpinner from "../../AnimationSpinner";
import loginImg from "../../assests/images/loginPage/loginpageBackground.png";
import darkLogo from "../../assests/images/dark-logo.png";
import { BsFillPersonFill } from "react-icons/bs";
import { handleInvalidToken } from "../../AuthUtils";
import axios from "axios";
import { RiLockPasswordFill } from "react-icons/ri";
import { FaRegEyeSlash } from "react-icons/fa";
import { FaRegEye } from "react-icons/fa";
import loginImage from "../../assests/images/change_password.png";

const ForgotPassReset = ({ base_url }) => {
	const [newPassword, setNewPassword] = useState("");
	const [confirmPassword, setConfirmPassword] = useState("");
	const [loading, setLoading] = useState(false);
	const { varificationCode } = useParams();
	const navigate = useNavigate();
	const [showNewPassword, setShowNewPassword] = useState(false);
	const [showConfirmPassword, setShowConfirmPassword] = useState(false);

	const handleShowNewPassword = () => {
		setShowNewPassword(!showNewPassword);
	};
	const handleShowConfirmPassword = () => {
		setShowConfirmPassword(!showConfirmPassword);
	};
	useEffect(() => {
		if (!varificationCode) {
			handleInvalidToken(navigate);
		}
	}, [varificationCode]);

	// sweetalert function--------------------------------------------------------
	function Sweetalert(field) {
		Swal.fire({
			icon: "error",
			title: "Validation Error",
			text: field + " is required!",
		});
	}
	// handle Submit reqst for reset password-----------------------------------
	const handleSubmit = (event) => {
		event.preventDefault();
		try {
			let isValid = true;
			if (!newPassword && !confirmPassword) {
				Sweetalert("Password & Confirm Password");
				isValid = false;
			} else {
				if (!newPassword) {
					Sweetalert("Password");
					isValid = false;
				}
				if (!confirmPassword) {
					Sweetalert("Confirm password");
					isValid = false;
				}
				if (newPassword.length < 6 || newPassword.length > 12) {
					Swal.fire({
						icon: "error",
						title: "Validation Error",
						text: "Password should be between 6 and 12 characters.",
					});
					isValid = false;
				}
				if (newPassword !== confirmPassword) {
					Swal.fire({
						icon: "error",
						title: "Validation Error",
						text: "Password and confirm Password doesn't match",
					});
					isValid = false;
				}
			}
			if (!isValid) {
				return;
			}
			setLoading(true);
			const formData = new FormData();
			formData.append("action", "resetPasswordAction");
			formData.append("new_password", newPassword);
			formData.append("confirm_password", confirmPassword);
			formData.append("verification_code", varificationCode);

			axios
				.post(`${base_url}api/user/forgot-password`, formData)
				.then((response) => {
					if (response.data.status === true) {
						setLoading(false);
						Swal.fire({
							icon: "success",
							title: "Password Changed",
							text: "Your password have been changed successfully.",
						});
						handleInvalidToken(navigate);
					} else {
						setLoading(false);
						Swal.fire({
							icon: "error",
							title: "Error",
							text: response.data.message,
						});
					}
				});
		} catch (error) {
			setLoading(false);
			Swal.fire({
				icon: "error",
				title: "Error",
				text:
					error.response?.data?.message ||
					error.message ||
					"Something went wrong. Please try again.",
			});
		}
	};

	return (
		<>
			<section className="login-box-wrapper">
				<AnimationSpinner show={loading} />
				<div className="container-fluid main-login-container">
					<div className="row justify-content-center d-flex custom-height">
						<div className="col-lg-9 col-md-8 col-sm-8 m-auto">
							<div className="login-box">
								<div className="row justify-content-center h-100">
									<div className="col-lg-6">
										<div className="left-login-container mx-auto">
											<div className="row w-100">
												<div className="col-lg-12">
													<div className="login-head mx-auto col-lg-12 text-left">
														<div className="login-logo">
															<img src={darkLogo} alt="Logo" />
														</div>
														<h2 className="title fs-lg-2">
															Welcome To CloneWeb AI
														</h2>
														<h6 className="sub-title fs-6">
															Reset your password below.
														</h6>
													</div>
													<div className="login-form">
														<form onSubmit={handleSubmit}>
															<div className="row mt-2">
																<div className="col-md-12 ">
																	<div className="form-group">
																		<div
																			data-mdb-input-init
																			className="form-outline "
																		>
																			<label htmlFor="form3Example1">
																				Enter Password
																			</label>
																			<div className="position-relative">
																				<input
																					type={
																						!showNewPassword
																							? "password"
																							: "text"
																					}
																					id="form3Example1"
																					className="form-control login-from-control mt-1"
																					placeholder="Enter your Password"
																					onChange={({ target: { value } }) =>
																						setNewPassword(value)
																					}
																				/>
																				<div
																					className="login-input-icon position-absolute"
																					onClick={handleShowNewPassword}
																					style={{ cursor: "pointer" }}
																				>
																					{showNewPassword ? (
																						<FaRegEyeSlash />
																					) : (
																						<FaRegEye />
																					)}
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
																<div className="col-md-12 ">
																	<div className="form-group">
																		<div
																			data-mdb-input-init
																			className="form-outline"
																		>
																			<label htmlFor="form3Example2">
																				Confirm Password
																			</label>
																			<div className="position-relative">
																				<input
																					type={
																						!showConfirmPassword
																							? "password"
																							: "text"
																					}
																					id="form3Example2"
																					className="form-control login-from-control mt-1"
																					placeholder="Confrim Password"
																					onChange={({ target: { value } }) =>
																						setConfirmPassword(value)
																					}
																				/>
																				<div
																					className="login-input-icon position-absolute"
																					onClick={handleShowConfirmPassword}
																					style={{ cursor: "pointer" }}
																				>
																					{showConfirmPassword ? (
																						<FaRegEyeSlash />
																					) : (
																						<FaRegEye />
																					)}
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
																<div className="col-md-12">
																	<div className="form-group">
																		<button
																			type="submit"
																			data-mdb-button-init
																			data-mdb-ripple-init
																			className="btn w-100 login-button"
																		>
																			Reset Password
																		</button>
																	</div>
																</div>
																<div className="col-md-12 text-center">
																	<div className="form-group text-center">
																		<div className="forgot-link ">
																			<span className="go-back">
																				Go back to{" "}
																			</span>
																			<Link to="/login" className="login-link">
																				Login
																			</Link>
																		</div>
																	</div>
																</div>
															</div>
														</form>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="col-lg-6">
										<div className="login-img-container ">
											{/* <div className="rlc-top">
																				<h1>Easily clone your sites</h1>
																				<p>
																					Lorem, ipsum dolor sit amet consectetur adipisicing
																					elit. Cupiditate magnam possimus deserunt temporibus!
																					Illum sit voluptatem, nemo ut velit sint?
																				</p>
																			</div> */}
											<div className="rlc-bottom">
												<img
													src={loginImage}
													alt=""
													style={{ objectFit: "contain" }}
												/>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};

export default ForgotPassReset;
